export const minimizeHtmlSpacing = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<html><body>${htmlString}</body></html>`, 'text/html');

    const mainWrapper = doc.querySelector('div[style*="max-width: 900px"]');
    if (mainWrapper) {
        let style = mainWrapper.getAttribute('style');
        style = style.replace(/padding:\s*[^;]+;/gi, 'padding: 0;');
        mainWrapper.setAttribute('style', style);
    }
    const blockElements = doc.querySelectorAll('div, h1, h2, h3, h4, h5, h6, p, ul, ol, li, span, img');

    blockElements.forEach(element => {
        let style = element.getAttribute('style');

        if (!style) {
            return;
        }
        style = style
            .replace(/margin-top:\s*[^;]+;/gi, '')
            .replace(/margin-bottom:\s*[^;]+;/gi, '')
            .replace(/margin:\s*[^;]+;/gi, '')
            .replace(/padding:\s*[^;]+;/gi, '')
            .replace(/line-height:\s*[^;]+;/gi, '');

        const tagName = element.tagName.toUpperCase();

        if (tagName === 'LI') {
            style = style.replace(/color:\s*[^;]+;/gi, '');
        }

        if (element.parentNode && element.parentNode.tagName === 'LI') {
            style = style
                .replace(/margin-bottom:\s*[^;]+;/gi, '')
                .replace(/color:\s*[^;]+;/gi, '');
        }

        if (tagName === 'SPAN' && element.parentNode.tagName === 'LI') {
            style = style.replace(/width:\s*[^;]+;/gi, '').replace(/flex:\s*[^;]+;/gi, '');
        }
        const newMargins = [];

        if (tagName === "P") {
            newMargins.push("margin-top: 0px;");
            newMargins.push("margin-bottom: 4px;");
        } else if (tagName.startsWith("H")) {
            newMargins.push("margin-top: 12px;");
            newMargins.push("margin-bottom: 10px;");
        } else if (tagName === "UL" || tagName === "OL") {
            newMargins.push("margin-top: 4px;");
            newMargins.push("margin-bottom: 4px;");
        } else if (tagName === "LI") {
            newMargins.push("margin-top: 0px;");
            newMargins.push("margin-bottom: 0px;");
        } else if (tagName === "DIV" && element.textContent.trim() !== "") {
            newMargins.push("margin-top: 2px;");
            newMargins.push("margin-bottom: 2px;");
        }
        style = style.trim() + ' ' + newMargins.join(' ');
        style = style.replace(/\s+/g, ' ').trim();
        element.setAttribute('style', style);
    });

    const boldElements = doc.querySelectorAll('b, strong');
    boldElements.forEach(element => {
        let style = element.getAttribute('style') || '';
        style = style.replace(/color:\s*[^;]+;/gi, '').trim();
        element.setAttribute('style', style);
    });
    return doc.body.innerHTML;
}


export const removePreImageContent = (htmlString, imageUrl) => {
    if (!imageUrl) return htmlString;
    const escapedUrl = imageUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const imgTagRegex = new RegExp(`(<img\\s+(?:[^>]*?\\s+)?src\\s*=\\s*(["'])` + escapedUrl + `\\2[^>]*>)`, 'i');

    const match = htmlString.match(imgTagRegex);

    if (match && match.index !== undefined) {
        const remainingContent = htmlString.substring(match.index + match[1].length);
        return remainingContent.trim();
    }

    return htmlString;
};

export function removePreImageContents(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<body>${html}</body>`, "text/html");

    const firstImg = doc.querySelector("img");

    if (!firstImg) return html;

    // Remove everything before the first image
    let node = firstImg.previousSibling;
    while (node) {
        const prev = node.previousSibling;
        node.remove();
        node = prev;
    }

    return doc.body.innerHTML;
}


export function removeHeaderImageBlock(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<body>${html}</body>`, "text/html");

    // Remove any heading (h1–h6) that contains an image
    doc.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach(h => {
        if (h.querySelector("img")) {
            h.remove();
        }
    });

    // Also remove any remaining images just in case
    doc.querySelectorAll("img").forEach(img => img.remove());

    return doc.body.innerHTML;
}
